import React, { FunctionComponent, ReactElement, memo } from 'react'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import CaptionFont from '../../../Theme/Fonts/Caption'
import VideoIndicator from '../../../BaseComponents/ProgressBar/VideoIndicator'
import { TestID } from '../../../utils/PropTypesDefinitions'

export type VideoControlsBottomLandscapeProps = {
    /** boolean to determine if different progressPercentages lead to animation */
    enableIndicatorProgress?: boolean
    /** current video time formatted as string */
    currentVideoTime: string
    /** duration formatted as string */
    formattedDuration: string
    /** the progress of the video in percent */
    videoProgressPercent: number
    /** the buffering of the video in percent */
    videoBufferingPercent: number
    /** callback when screen mode changes
     *
     * @TJS-type function
     * */
    onScreenModeChange: () => void
    /** callback when the dragging of the knob ends
     *
     * @TJS-type function
     * */
    onSeekEnd: (progress: number) => void
    /** callback when the dragging of the knob starts
     *
     * @TJS-type function
     * */
    onSeekStart: () => void
    /** the duration of the video */
    duration: number
} & TestID

const VideoControlsBottomLandscape: FunctionComponent<VideoControlsBottomLandscapeProps> = ({
    enableIndicatorProgress,
    currentVideoTime,
    formattedDuration,
    videoProgressPercent,
    videoBufferingPercent,
    onScreenModeChange,
    onSeekEnd,
    onSeekStart,
    duration,
    testID,
}): ReactElement => {
    return (
        <Grid paddingLeft={2} horizontal centerVertical testID={testID} noExpand>
            <CaptionFont bold color="WHITE">
                {currentVideoTime}
            </CaptionFont>
            <Grid marginX={5}>
                <VideoIndicator
                    enableIndicatorProgress={enableIndicatorProgress}
                    progressPercent={videoProgressPercent}
                    bufferingPercent={videoBufferingPercent}
                    onSeekEnd={onSeekEnd}
                    onSeekStart={onSeekStart}
                    duration={duration}
                />
            </Grid>
            <CaptionFont bold color="WHITE">
                {formattedDuration}
            </CaptionFont>
            <Touchable onPress={onScreenModeChange}>
                <Grid noExpand horizontal width={44} height={44} center>
                    <Grid noExpand>
                        <FontelloIcon name="fullscreen-exit" color="WHITE" />
                    </Grid>
                </Grid>
            </Touchable>
        </Grid>
    )
}

export default memo(VideoControlsBottomLandscape)
